class cartRecommendations extends HTMLElement {
    constructor() {
        super();

        this.cartModels = this.querySelectorAll(".js-cart-model");
        this.openModelEl = this.querySelectorAll("[js-open-add-to-cart-model]");
        this.quickAddToCartBtn = this.querySelectorAll("[js-quick-add-to-cart]");
        this.addToCartBtn = this.querySelectorAll("[js-add-to-cart]");
        this.variantItem = this.querySelectorAll(".js-variant-item");

        this.init();
    };

    init() {
        const self = this;

        this.openModelEl.forEach( btn => {
            btn.addEventListener('click',  function () {
                const modelId = this.getAttribute('id');

                self.openModel(modelId);
                self.activeModel = self.querySelector(".js-cart-model.active");
                self.getVariants();
            });
        });
        this.quickAddToCartBtn.forEach( btn => {
            btn.addEventListener('click', function() {
                const variantId = this.dataset.variantId;
                const data = {
                    id: variantId,
                    quantity: 1,
                };

                this.classList.add("btn--loading");
                self.addToCart(data, "", this);
            })
        })
        this.addToCartBtn.forEach( btn => {
            btn.addEventListener('click',  function () {
                const currentModel = this.closest(".js-cart-model");
                const variantId = this.dataset.variantId;
                const qty = self.getQty(currentModel.querySelector(".js-qty__num"));

                const data = {
                    id: variantId,
                    quantity: qty,
                };

                this.classList.add("btn--loading");
                self.addToCart(data, currentModel, this);
                
            });
        });
        this.variantItem.forEach( item => {
            item.addEventListener('click', function() {
                self.updateState(this);
                const selectedOption = self.getCurrentOptions(this);
                const variant = self.getFullMatch(selectedOption);
                self.updateVariantId(variant);
            })
        });

        document.addEventListener('click',  (e) => {
            if(!this.activeModel) return;

            if (!this.activeModel.contains(e.target) && !e.target.classList.contains("js-contents")){
                this.closeModel();
            }
        });

        this.initQtySelectors();
    };

    openModel(modelId) {
        this.cartModels.forEach( model => model.classList.remove('active'));
        this.querySelector(`[data-model-id=${modelId}]`).classList.add('active');
    };

    closeModel() {
        const activeModel = this.querySelector('.js-cart-model.active')
        if(activeModel) {
            activeModel.classList.remove('active');
        }
    };

    initQtySelectors() {
        this.querySelectorAll(".js-qty-wrap").forEach(el => {
          new theme.QtySelector(el, {
            isCart: false
          });
        });
    };

    getQty(inputField) {
        var qty = inputField.value;
        
        return parseInt(qty);
    };

    updateState(currentOption) {
        this.activeModel.querySelectorAll(".js-variant-item").forEach( item => item.classList.remove("selected"));
        currentOption.classList.add("selected");
    };

    getVariants() {
        const variantJson = this.activeModel.querySelector("[data-variant-json]");
        this.variants = JSON.parse(variantJson.innerHTML);
    };

    getCurrentOptions(currentOption) {
        var result = [];
  
        result.push({
            value: currentOption.dataset.value,
            index: currentOption.dataset.index
        });
  
        return result;
    };

    getFullMatch(selectedOption) {
        return this.variants.find(variant => {
            const isMatch = selectedOption.every(({value, index}) => {
              return variant[index] === value;
            });

            return isMatch;
        });
    };

    updateVariantId(variant) {
        this.activeModel.querySelector("[js-add-to-cart]").setAttribute("data-variant-id", variant.id);
    };

    addToCart(data, currentModel, targetBtn) {
        fetch('/cart/add.js', {
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          }).then(function(response) {
            return response.json();
          }).then((data) => {
            targetBtn.classList.remove("btn--loading");

            if (data.status === 422) {
                if(!currentModel) return;
                currentModel.querySelector(".error-message").innerHTML = data.description;
            } else {
                if(currentModel) {
                    this.closeModel();
                };

                document.dispatchEvent(new CustomEvent('cart:build')); 
                document.dispatchEvent(new CustomEvent('cart:open'));
            }

          }).catch(err => {
            console.log(err)
          })
    };
}
  
customElements.define('cart-recommendations', cartRecommendations);
  